import type { ResourceConfig } from "../types";

export const coachGoalConfig = {
  displayName: "教练目标",
  category: "coach-goal",
  permissions: {
    "read:all": {
      label: "查看所有教练目标",
      description: "可以查看所有教练的月度目标",
    },
    "write:all": {
      label: "设置教练目标",
      description: "可以设置和删除所有教练的月度目标",
    },
  },
} satisfies ResourceConfig;
